export const nationalities = [
    {
      name: "argentino /a",
      value: "ARGENTINO"
    },
    {
      name: "boliviano /a",
      value: "BOLIVIANO"
    },
    {
      name: "chileno /a",
      value: "CHILENO"
    },
    {
      name: "colombiano /a",
      value: "COLOMBIANO"
    },
    {
      name: "costarricense",
      value: "COSTARRICENSE"
    },
    {
      name: "cubano /a",
      value: "CUBANO"
    },
    {
      name: "dominicano /a",
      value: "DOMINICANO"
    },
    {
      name: "ecuatoriano /a",
      value: "ECUATORIANO"
    },
    {
      name: "estadounidense",
      value: "ESTADOUNIDENSE"
    },
    {
      name: "filipino /a",
      value: "FILIPINO ",
    },
    {
      name: "guatemalteco /a",
      value: "GUATELMATECO"
    },
    {
      name: "hondureño /a",
      value: "HONDUREÑO"
    },
    {
      name: "mexicano /a",
      value: "MEXICANO"
    },
    {
      name: "nicaragüense",
      value: "NICARAGUENSE"
    },
    {
      name: "panameño /a",
      value: "PANAMEÑO"
    },
    {
      name: "paraguayo /a",
      value: "PARAGUAYO"
    },
    {
      name: "puertorriqueño /a",
      value: "PUERTORRIQUEÑO"
    },
    {
      name: "peruano /a",
      value: "PERUANO"
    },
    {
      name: "salvadoreño /a",
      value: "SALVADOREÑO"
    },
    {
      name: "uruguayo /a",
      value: "URUGUAYO"
    },
    {
      name: "venezolano /a",
      value: "VENEZOLANO"
    },
    {
      name: "otro /a",
      value: "OTRO"
    }
]

export const sexs = [
    {
      name: "Masculino",
      value: "MASCULINO"
    },
    {
      name: "Femenino",
      value: "FEMENINO"
    }
]

export const maritalStatuses = [
    {
      name: "Soltero",
      value: "SOLTERO"
    },
    {
      name: "Casado",
      value: "CASADO"
    },
    {
      name: "Viudo",
      value: "VIUDO"
    },
    {
      name: "Divorciado",
      value: "DIVORCIADO"
    }
]